import { getDocument, getWindow } from 'ssr-window';
const safeDocument = getDocument();
const safeWindow = getWindow();
if (typeof safeDocument.body.appendChild !== 'function') {
    safeDocument.body.appendChild = (child) => child;
}
export { safeDocument, safeWindow };
